import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as moment from 'moment';

@Component({
  selector: 'app-date-range',
  templateUrl: './date-range.component.html',
  styleUrls: ['./date-range.component.scss']
})
export class DateRangeComponent implements OnInit {
  startDate: any = new Date();
  endDate: any = new Date();
  maxDate = new Date();
  disableOk = false;

  constructor(
    public dialogRef: MatDialogRef<DateRangeComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    this.disableOkayLogic();
  }

  onSelect(e, date) {
    this.disableOk = false;
    if (date === 'start') {
      this.startDate = moment(e).format('YYYY-MM-DD');
      this.data.startDate = new Date(e);
    } else {
      this.endDate = moment(e).format('YYYY-MM-DD');
      this.data.endDate = new Date(e);
    }
    this.disableOkayLogic();
  }

  submitDateRange(startDate, endDate) {
    let data = {
      'startDate': moment(startDate).format('YYYY-MM-DD'),
      'endDate': moment(endDate).format('YYYY-MM-DD')
    }
  }

  disableOkayLogic() {
    if ((this.data.endDate.getTime() - this.data.startDate.getTime()) / (1000 * 60 * 60 * 24) > 365) {
      this.disableOk = true;      
    }
  }
  
}